import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class TimeOfDayService {

  timeOfDay: Observable<Date>;

  constructor() {
    this.timeOfDay = Observable.interval(1000).map(tick => new Date()).share();
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/services/time-of-day.service.ts